import * as Sentry from "@sentry/vue";
import posthog from "posthog-js";

import config from "@/config";
import {
  AnalyticsProviderApiKeyMissingError,
  AnalyticsProviderInitializationError,
} from "@/lib/analytics/exceptions";

import type { AnalyticsEvent } from "@/enums/analytics";
import type { AnalyticsProvider } from "@/lib/analytics/analytics";

export class PostHogAnalyticsProvider implements AnalyticsProvider {
  init() {
    if (!config.posthogApiKey) {
      console.error(
        new AnalyticsProviderApiKeyMissingError(PostHogAnalyticsProvider.name)
      );
      return false;
    }
    try {
      posthog.init(config.posthogApiKey, {
        api_host: "https://us.i.posthog.com",
        defaults: "2025-11-30",
        person_profiles: "identified_only",
        session_recording: {
          recordCrossOriginIframes: true,
        },
      });
      return true;
    } catch (error) {
      Sentry.captureException(
        new AnalyticsProviderInitializationError(
          PostHogAnalyticsProvider.name,
          error as Error
        )
      );
      return false;
    }
  }

  trackEvent(eventName: AnalyticsEvent, properties?: Record<string, unknown>) {
    posthog.capture(eventName, properties);
  }

  onUserChange<TUserData extends { id: string | number } | null>(
    userData: TUserData | null
  ) {
    if (!userData) {
      posthog.reset();
      return;
    }

    posthog.identify(String(userData.id), userData);
  }

  onUserPropertiesChange<TData extends Record<string, unknown>>(
    properties: TData
  ) {
    posthog.setPersonProperties(properties);
  }
}
